import React from "react";
import {
  Card,
  CardContent,
  Typography,
  Box,
  Grid,
  Divider,
} from "@mui/material";
import ArrowDropUpIcon from "@mui/icons-material/ArrowDropUp";
import RemoveIcon from "@mui/icons-material/Remove";

interface SummaryItem {
  label: string;
  value: number | string;
  change?: number;
}

interface SummaryPanelProps {
  items: SummaryItem[];
}

const SummaryPanel: React.FC<SummaryPanelProps> = ({ items }) => {
  const getChangeColor = (change?: number) => {
    if (change === 0) return "#FDBA12"; // yellow for 0%
    if (change && change > 0) return "#16C784"; // green for positive
    if (change && change < 0) return "#E74C3C"; // red for negative
    return "#A0AEC0";
  };

  const getChangeIcon = (change?: number) => {
    if (change === 0)
      return (
        <RemoveIcon sx={{ fontSize: 18, color: getChangeColor(change) }} />
      );
    if (change && change > 0)
      return (
        <ArrowDropUpIcon sx={{ fontSize: 24, color: getChangeColor(change) }} />
      );
    if (change && change < 0)
      return (
        <ArrowDropUpIcon
          sx={{
            fontSize: 24,
            transform: "rotate(180deg)",
            color: getChangeColor(change),
          }}
        />
      );
    return null;
  };

  return (
    <Card
      sx={{
        borderRadius: 3,
        boxShadow: "0 2px 10px rgba(0,0,0,0.05)",
        height: "100%",
        display: "flex",
        flexDirection: "column",
        backgroundColor: "#fff",
      }}
    >
      <CardContent sx={{ p: 2.5 }}>
        <Grid container direction="column">
          {items.map((item, idx) => (
            <React.Fragment key={idx}>
              <Grid
                item
                container
                alignItems="center"
                justifyContent="space-between"
                sx={{ py: 1 }}
              >
                <Grid item xs={8}>
                  <Typography
                    variant="body2"
                    sx={{
                      color: "#1C4E80",
                      fontWeight: 500,
                      fontSize: "15px",
                    }}
                  >
                    {item.label}
                  </Typography>
                  <Box display="flex" alignItems="center" mt={0.3}>
                    {getChangeIcon(item.change)}
                    {item.change !== undefined && (
                      <Typography
                        variant="caption"
                        sx={{
                          color: getChangeColor(item.change),
                          fontWeight: 600,
                          ml: 0.3,
                          fontSize:"14px"
                        }}
                      >
                        {item.change}%
                      </Typography>
                    )}
                  </Box>
                </Grid>
                <Grid item xs={4}>
                  <Typography
                    variant="h6"
                    align="right"
                    sx={{
                      color: "#1C4E80",
                      fontWeight: 500,
                      fontSize: "20px",
                    }}
                  >
                    {item.value}
                  </Typography>
                </Grid>
              </Grid>
              {idx < items.length - 1 && (
                <Divider sx={{ borderColor: "#D5EFFF" }} />
              )}
            </React.Fragment>
          ))}
        </Grid>
      </CardContent>
    </Card>
  );
};

export default SummaryPanel;
